/**
 * BattleCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleCreateReq
 */
export interface BattleCreateReq {
  /** 创建用户ID（为空则使用官方账号） */
  create_user_id?: string
  /** 创建员工ID */
  create_staff_id?: string
  /** 红方战队名称 */
  red_team_name: string
  /** 蓝方战队名称 */
  blue_team_name: string
  /** 红方战队头像ID */
  red_team_avatar_id?: string
  /** 蓝方战队头像ID */
  blue_team_avatar_id?: string
}

/**
 * BattleCreateReq Schema
 */
export const BattleCreateReqSchema: SchemaDefinition = {
  properties: {
    create_user_id: {
      description: '创建用户ID（为空则使用官方账号）',
      format: 'string',
      type: 'string',
      label: '创建用户ID',
    },
    create_staff_id: {
      description: '创建员工ID',
      format: 'string',
      type: 'string',
      label: '创建员工ID',
    },
    red_team_name: {
      description: '红方战队名称',
      format: 'string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '红方战队名称',
    },
    blue_team_name: {
      description: '蓝方战队名称',
      format: 'string',
      maxLength: 50,
      minLength: 1,
      type: 'string',
      label: '蓝方战队名称',
    },
    red_team_avatar_id: {
      description: '红方战队头像ID',
      format: 'string',
      type: 'string',
      label: '红方战队头像ID',
    },
    blue_team_avatar_id: {
      description: '蓝方战队头像ID',
      format: 'string',
      type: 'string',
      label: '蓝方战队头像ID',
    },
  },
  required: ['red_team_name', 'blue_team_name'],
  type: 'object',
}
